<p>
  Ако сте намерили артикул, който желаете да закупите, може да го направите директно от страницата на обявата чрез
  бутона <strong>„Купи сега“</strong>.
</p>
<h6 class="mt-3">Стъпки за покупка:</h6>
<ol>
  <li>Отворете страницата на избрания артикул.</li>
  <li>Натиснете бутона <strong>„Купи сега“</strong>, разположен под цената на артикула.</li>
  <li>Ще се появи прозорец за потвърждение на покупката, съдържащ кратка информация за артикула и крайната цена.</li>
  <li>Потвърдете действието чрез избрания от вас метод – <strong>ПИН код</strong> или <strong>парола</strong>. Методът
    се задава от:
    <strong>„Профил“ → „Настройки“</strong>.
  </li>
  <li>След потвърждение, сделката се счита за успешно сключена.</li>
</ol>
<h6 class="mt-3">Какво се случва след покупка?</h6>
<p class="mb-1">
  Платформата автоматично ще уведоми продавача и ще създаде чат между вас. В него може да:
</p>
<ul>
  <li>Уточните детайли по <strong>доставката</strong> и <strong>плащането</strong>;</li>
  <li>Предоставите адрес за доставка или допълнителна информация;</li>
  <li>Получите потвърждение и проследите хода на изпращането.</li>
</ul>
<h6 class="mt-3">След приключване на сделката</h6>
<p>
  Ще имате възможност да оставите <strong>отзив</strong> за продавача. Това е важен елемент от изграждането на доверие
  между потребителите и спомага за по-добра оценка на търговската история на участниците в платформата.
</p>
<p>
  Историята на всички ваши покупки може да намерите в <strong>„Профил“ → „Моите покупки“</strong>.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Уверете се, че използвате надежден метод за потвърждение (ПИН или парола), за да избегнете
  неволни или неоторизирани действия. При нужда, може да промените метода по всяко време от
  <strong>„Профил“ → „Настройки“</strong>.
</div>
